import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Loading from '../common/Loading.js';
import ErrorMessage from '../common/ErrorMessage.js';
import ArtistService from '../../services/artistService';
import ToastrService from '../../services/toastrService';
import { Redirect } from 'react-router-dom';
import MaterialDropDown from '../common/MaterialDropDown.js';
import MaterialInput from '../common/MaterialInput.js';
/* global google */

class EditBuyMe extends React.Component {
    constructor(props, context) {
        super(props, context);      
        this.initialise = this.initialise.bind(this);
        this.removeBuyOption = this.removeBuyOption.bind(this);
        this.addBuyOption = this.addBuyOption.bind(this);
        this.showAdd = this.showAdd.bind(this);
        this.closeShowAdd = this.closeShowAdd.bind(this);
        this.updateNewBuyOptionField = this.updateNewBuyOptionField.bind(this);   
      
        this.buyLinkTypes = ['iTunes', 'Amazon', 'BandCamp', 'CDBaby', 'NoiseTrade', 'Other'];

        this.state = {
            profile: this.props.profile,
            buyOptions: [],
            loadingBuyOptions: false,
            showAdd: false,
            newBuyOption: {}            
        };
     }

    componentWillMount() {
        this.initialise();
    }

    componentDidMount() { 
        
    }

    componentWillUpdate(nextProps, nextState) {
        if(nextProps.profile.ID !== this.props.profile.ID) {
            this.setState({
                profile: nextProps.profile,
                buyOptions: []
            }, this.initialise);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const showingAddBuyOption = this.state.showAdd && !prevState.showAdd;
        if(showingAddBuyOption) {
            window.componentHandler.upgradeDom();  
            const {getmdlSelect} = require('../../scripts/getmdl-select.js');
            getmdlSelect.init('#divCreateProfile .getmdl-select');   
        }    
    }

    initialise(clearProfileBuyOptions = false) {
        this.setState({ loadingBuyOptions: true, error: null });        
        this.props.actions.getBuyOptions(this.state.profile.ID)
            .then(buyOptions => {
                this.setState({ loadingBuyOptions: false, buyOptions });
                if(clearProfileBuyOptions) {
                    this.props.actions.clearProfileBuyOptions(this.state.profile.ID);
                }
            })
            .catch(error => this.setState({ loadingBuyOptions: false }));
    }

    removeBuyOption(event, buyOption) {
        event.preventDefault();
        if(confirm(`Remove link '${buyOption.Url}' from your LoudUp page?`)) {
            this.props.actions.deleteBuyOption(this.state.profile.ID, buyOption.ID)
                .then(_ => {
                   this.initialise(true);
                   const toastrService = new ToastrService();
                    toastrService.showSuccess('', 'The link has been removed successfully');
                })
                .catch(error => {
                    this.setState({ error: 'Sorry, something went wrong, unable to delete link' });
                });
        }
        else {
            return false;
        }
    }

    addBuyOption(event) {
        event.preventDefault();
        if(!this.state.newBuyOption.Url) {
            this.setState({ error: "Please enter the link" });
        }
        else if(!this.state.newBuyOption.Description) {
            this.setState({ error: "Please enter the description" });
        }
        else {
            this.setState({ error: null });
            const buyOption = {...this.state.newBuyOption};     
            this.props.actions.addBuyOption(this.state.profile.ID, buyOption)
                .then(buyOptions => { 
                    this.setState({ buyOptions, newBuyOption: { }, showAdd: false });
                    this.props.actions.clearProfileBuyOptions(this.state.profile.ID);
                })
                .catch(error => {
                    this.setState({ error: error.message });
                });
        }        
    }

    showAdd(event) {
        event.preventDefault();
        this.setState({ showAdd: true });
    }

    closeShowAdd(event) {
        event.preventDefault();
        this.setState({ showAdd: false, newBuyOption: { }, error: null });
    }

    updateNewBuyOptionField(event) {
        const name = (event.target.name || event.target.attributes['name'].value);
        let value;
        if(event.target.className === 'mdl-checkbox__input') {
            value = event.target.checked;
        }
        else if (event.target.className === 'mdl-menu__item') {
            value = event.target.dataset.val;// event.target.innerText;
        }  
        else {
            value = event.target.value;
        }
        const newBuyOption = {...this.state.newBuyOption};
        newBuyOption[name] = value;
        this.setState({ newBuyOption });
    }

    render() {
        return (
            !ArtistService.showBuyLinks(this.props.profile.RoleType) ?
                <Redirect to="/Profile/Manage" />
                :
                <div id="divCreateProfile">                        
                    {
                        this.state.showAdd ?                                
                            <form id="frmAddBuyOption" className="form-tightfields form-regular" onSubmit={this.addBuyOption}>                                    
                                <a href="#" style={{float:'right'}} onClick={this.closeShowAdd}>Close</a>
                                <p style={{fontWeight: 'bold', textAlign: 'center'}}>Add new purchase link</p>
                                <ErrorMessage error={this.state.error} onClose={() => this.setState({ error: null })} />
                                <MaterialDropDown 
                                    name="Description" 
                                    value={this.state.newBuyOption.Description} 
                                    required 
                                    data={this.buyLinkTypes} 
                                    onClick={this.updateNewBuyOptionField}
                                    className={`getmdl-select__fullwidth getmdl-select--limited placeholder ${this.state.newBuyOption.Description ? 'is-dirty': ''}`} />
                                <MaterialInput type="url" name="Url" value={this.state.newBuyOption.Url} onChange={this.updateNewBuyOptionField} maxLength="150" />
                                <br />
                                <br />
                                <input type="submit" className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--accent mdl-button--wide" value="ADD" onClick={this.addBuyOption} />                                  
                            </form>
                        : 
                            <React.Fragment>
                                <ErrorMessage error={this.state.error} onClose={() => this.setState({ error: null })} />
                                <a id="aAddNewBuyOption" href="#" className="btn-simple transition" onClick={this.showAdd}>Add new link →</a>                       
                                <div id="loudUpBuyOptions">                        
                                    <p className="formlegend">Existing buy links</p>
                                    <div className="table-info visible-xs">&#8592; SCROLLABLE &#8594;</div>
                                    <div className="table-responsive">
                                        <table id="uploaded" className="table table-striped table-results gig-listings">
                                            <thead>
                                                <tr>
                                                    <th>DESCRIPTION</th>
                                                    <th>URL</th>
                                                    <th>&nbsp;</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.state.buyOptions.length ?
                                                        this.state.buyOptions.map(buyOption => 
                                                            <tr key={buyOption.ID} className="transition">
                                                                <td>
                                                                    {buyOption.Description}
                                                                </td>
                                                                <td>
                                                                    {buyOption.Url}
                                                                </td>
                                                                <td>
                                                                    <a href="#" className="btn-simple transition" onClick={(e) => this.removeBuyOption(e, buyOption)}>Remove</a>
                                                                </td>
                                                            </tr>   
                                                        )                                            
                                                    : 
                                                    <tr>
                                                        <td colSpan="3" style={{textAlign: 'center'}}>
                                                            {
                                                                this.state.loadingBuyOptions ? 
                                                                    <Loading /> 
                                                                    : 'No buy links have been added to your LoudUp page yet'
                                                            }
                                                        </td>
                                                    </tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>                                   
                            </React.Fragment>
                    }                        
                </div>        
        );
    }
}

EditBuyMe.propTypes = {
    profile: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired
};

export default EditBuyMe;